import { FmsField, QueuedTeam, TimedField } from "./practice.models";

export function addEstimatedWaits(practiceField: FmsField|TimedField, now: number): void {
  const queueLength = practiceField.queue?.length || 0;
  if(practiceField.type === 'FMS') {
    const slots = 6;
    const lastMatchStartedAt = Object.values(practiceField.matches || {}).reduce((last, match) => Math.max(last, match.completeTimestamp || 0), 0);
    const lastMatchDiff = now - lastMatchStartedAt;
    const cycleRemaining = Math.max(0, practiceField.cycleTimeSeconds - lastMatchDiff / 1000);

    for(let i = 0; i < queueLength; i++) {
      const seconds = Math.round(cycleRemaining + Math.floor(i / slots) * practiceField.cycleTimeSeconds);
      practiceField.queue![i].estimatedExitTimestamp = now + (seconds * 1000);
      practiceField.queue![i].remainingWait = getEstimatedWaitString(seconds);
    }

    practiceField.estimatedWaitSeconds = Math.round(cycleRemaining + Math.floor(queueLength / slots) * practiceField.cycleTimeSeconds);
    practiceField.estimatedWait = getEstimatedWaitString(practiceField.estimatedWaitSeconds);
    practiceField.status = practiceField.open ? practiceField.estimatedWait : (practiceField.closedMessage || $localize `Closed`);

    return;
  }

  const slots = practiceField.areas.length;
  const times = practiceField.areas.map(area => Math.max(0, (practiceField.timerSeconds) - ((now - (area.timerStarted || (area.team ? now : 0))) / 1000))).sort((a, b) => a - b);

  for(let i = 0; i < queueLength; i++) {
    const mod = i % slots;
    const mult = Math.floor(i / slots);
    const seconds = times[mod] + (mult * (practiceField.timerSeconds + practiceField.bufferSeconds));
    practiceField.queue![i].estimatedExitTimestamp = now + Math.round(seconds * 1000);
    practiceField.queue![i].remainingWait = getEstimatedWaitString(seconds);
  }

  const mod = queueLength % slots;
  const mult = Math.floor(queueLength / slots);
  const time = times[mod] + (mult * (practiceField.timerSeconds + practiceField.bufferSeconds));
  practiceField.estimatedWaitSeconds = Math.round(time);
  practiceField.estimatedWait = getEstimatedWaitString(practiceField.estimatedWaitSeconds);
  practiceField.status = practiceField.open ? practiceField.estimatedWait : (practiceField.closedMessage || $localize `Closed`);
}

export function getEstimatedWaitString(seconds: number): string {
  const minutes = Math.round(seconds / 60);
  const roundedMinutes = Math.ceil(minutes / 5) * 5;
  if(roundedMinutes < 15) {
    return $localize `:Indicating a wait time of less than 15 minutes:<15m wait`;
  }

  if(roundedMinutes >= 60) {
    const minutes = roundedMinutes % 60;
    const hours = Math.floor(roundedMinutes / 60);
    if(minutes) {
      return  $localize `:Indicating an approximate wait time of X hours and Y minutes:~${hours}h ${minutes}m wait`;
    }
    return $localize `:Indicating an approximate wait time of X hours:~${hours}h wait`;
  }

  return  $localize `:Indicating an approximate wait time of X minutes:~${roundedMinutes}m wait`;
}

export function practiceQueueComparator(a: QueuedTeam, b: QueuedTeam) {
  if(a.priority && !b.priority) return -1;
  if(b.priority && !a.priority) return 1;

  return (a.enterTimestamp || 0) - (b.enterTimestamp || 0);
}
